import { render, staticRenderFns } from "./RoomRequest.vue?vue&type=template&id=09927984&"
import script from "./RoomRequest.vue?vue&type=script&lang=js&"
export * from "./RoomRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports